import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faHandSparkles } from "@fortawesome/free-solid-svg-icons";
import "./ChooseOptionModal.css";

const originalSummary =
  "Highly motivated Front-end Developer with over 3 yrs of experience in designing, developing, and deploying responsive web applications using HTML, CSS, React, JavaScript, and Bootstrap. Known for optimizing user experience, improving site performance, and collaborating effectively with cross-functional teams. Adept at delivering scalable web solutions that align with business objectives and user needs.";

const summaries = [
  "Frontend Development Engineer with 3 years at Pratian Technologies, excelling in React, JavaScript, and Agile Methodology to deliver high-quality web applications. Proven track record of improving performance and delivering scalable React applications.",

  "Experienced Frontend Developer skilled in React, HTML5, CSS3, JavaScript, Bootstrap, and Agile development. Passionate about building responsive, user-friendly applications while collaborating effectively with cross-functional teams.",

  "B.Tech graduate and Frontend Engineer with over 3 years of experience leading UI development using React, JavaScript, Bootstrap, and modern web technologies. Strong problem-solving skills with a focus on delivering high-quality user experiences.",
];



const ChooseOptionModal = ({
  show,
  handleClose,
  setProfileSummary,
  openProfileSummary,
}) => {

  const [expandedCard, setExpandedCard] = useState(null);
  
  const handleReadMore = (index) => {
    setExpandedCard(index);
  };

  const handleReadLess = () => {
    setExpandedCard(null);
  };

  const insertSummary = (summary) => {
    setProfileSummary(summary);
    handleClose();
    openProfileSummary();
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      size="lg"
      dialogClassName="common-modal choose-option-modal"
    >
      <Modal.Header className="we-modal-header d-flex align-items-center">
        <Modal.Title className="we-modal-title">
          <Button
            variant="link"
            className="we-back-btn p-0 me-2"
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faAngleLeft} />
          </Button>
          Choose an option
        </Modal.Title>

        <button
          type="button"
          className="btn-close ms-auto"
          onClick={handleClose}
        ></button>
      </Modal.Header>

      <Modal.Body className="choose-option-modal__body">
        {/* Original Summary */}
        <div className="choose-option-modal__card choose-option-modal__card--active">
          <div className="choose-option-modal__badge">Original</div>

          <p>
            {expandedCard === "original"
              ? originalSummary
              : `${originalSummary.substring(0, 150)}...`}

            {expandedCard === "original" ? (
              <>
                <span
                  className="choose-option-modal__readmore"
                  onClick={handleReadLess}
                >
                  Read less
                </span>

                <div className="summary-preview-box">
                  <Button
                    className="summary-preview-btn"
                    onClick={() => insertSummary(originalSummary)}
                  >
                    Insert Summary
                  </Button>

                  <div className="summary-preview-info">
                    ⓘ You will have the option to make edits after inserting
                    this.
                  </div>
                </div>
              </>
            ) : (
              <span
                className="choose-option-modal__readmore"
                onClick={() => handleReadMore("original")}
              >
                Read more
              </span>
            )}
          </p>
        </div>

        <h5 className="choose-option-modal__heading">
          <FontAwesomeIcon icon={faHandSparkles} className="me-2" />
          AI generated summary
        </h5>

        {summaries.map((item, index) => (
          <div key={index} className="choose-option-modal__card">
            <p>
              {expandedCard === index ? item : `${item.substring(0, 150)}...`}

              {expandedCard === index ? (
                <>
                  <span
                    className="choose-option-modal__readmore"
                    onClick={handleReadLess}
                  >
                    Read less
                  </span>

                  <div className="summary-preview-box">
                    <Button
                      className="summary-preview-btn"
                      onClick={() => insertSummary(item)}
                    >
                      Insert Summary
                    </Button>

                    <div className="summary-preview-info">
                      ⓘ You will have the option to make edits after inserting
                      this.
                    </div>
                  </div>
                </>
              ) : (
                <span
                  className="choose-option-modal__readmore"
                  onClick={() => handleReadMore(index)}
                >
                  Read more
                </span>
              )}
            </p>
          </div>
        ))}
      </Modal.Body>
    </Modal>
  );
};

export default ChooseOptionModal;
